const comments = [
  {
    name: '追剧小达人',
    time: '2小时前',
    content: '画质真的太好了，4K看着就是爽！而且完全免费，之前用的几个平台都要会员才能看高清，桃子影院良心平台，已经推荐给身边所有追剧的朋友了。',
    drama: '在看《庆余年3》',
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20portrait%20of%20young%20Asian%20woman%20with%20warm%20smile%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20casual%20style%2C%20friendly%20and%20approachable%20look&width=80&height=80&seq=avatar-cm-01&orientation=squarish',
  },
  {
    name: '深夜放映室',
    time: '5小时前',
    content: '更新速度没得说，韩剧那边刚播完这边就有了，追剧就靠桃子影院了。画质流畅度也完全OK，移动端体验也很棒，睡前刷一集美滋滋。',
    drama: '在看《眼泪女王》',
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20portrait%20of%20young%20Asian%20man%20with%20gentle%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20casual%20modern%20style%2C%20friendly%20look&width=80&height=80&seq=avatar-cm-02&orientation=squarish',
  },
  {
    name: '剧荒拯救者',
    time: '1天前',
    content: '免费还没有广告，这个真的太难得了。资源特别全，想看的国产剧韩剧美剧基本都能找到。分类也很清晰，找剧很方便。希望一直做下去！',
    drama: '在看《狂飙》',
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20portrait%20of%20young%20Asian%20woman%20with%20bright%20smile%2C%20simple%20clean%20background%2C%20natural%20lighting%2C%20modern%20casual%20style%2C%20energetic%20and%20friendly&width=80&height=80&seq=avatar-cm-03&orientation=squarish',
  },
  {
    name: '电影爱好者小李',
    time: '2天前',
    content: '从朋友那里知道桃子影院的，试了一下真的惊艳到了。蓝光画质秒开，完全没有缓冲等待，比那些大平台体验还好。已经成了我的主力追剧站。',
    drama: '在看《三体》',
    avatar: 'https://readdy.ai/api/search-image?query=Profile%20portrait%20of%20Asian%20man%20with%20thoughtful%20expression%2C%20simple%20clean%20background%2C%20soft%20natural%20lighting%2C%20casual%20style%2C%20intellectual%20friendly%20look&width=80&height=80&seq=avatar-cm-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-50 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
          观众热评
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((cm, i) => (
            <div key={i} className="bg-background-100 rounded-lg border border-background-200/70 p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={cm.avatar} alt={cm.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{cm.name}</h3>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{cm.time}</span>
                  </div>
                  <span className="text-xs text-accent-600 bg-accent-50 px-2 py-0.5 rounded whitespace-nowrap">{cm.drama}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{cm.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}